import type { AuthUser } from '@/api/auth';
import { IS_APP_BUILD } from '@/lib/appBrand';
import { computeHasFeature } from '@/stores/auth';

/**
 * Есть ли у ученика разговорные комнаты и живые уроки — ОДНО правило для маршрутов и для кнопки «Войти» в календаре
 * (02.10.2026, решение владельца к 1.1.1: комнаты и уроки в приложении — только микрофон; вход — из календаря).
 *
 * Комната — раздел `speaking_peers`, живой урок — `live`. Есть раздел — событие и кнопка «Войти» есть, вход ведёт
 * внутрь приложения (`/app/speaking/<id>`, `/app/live/<id>`); нет раздела — нет ни события, ни кнопки, ни запроса.
 * Замков, «скоро» и нажатий в пустоту не бывает ни в одном случае.
 *
 * ⚠️ СЕРВЕР КОМНАТЫ ТАРИФОМ НЕ ЗАКРЫВАЕТ: у `/student/speaking-rooms` только вход, а комнату с адресатом «всем»
 * получил бы и бесплатник. Закрывает именно это правило — поэтому календарь обязан спрашивать его, а не рисовать
 * всё, что прислал сервер.
 *
 * ⚠️ В ПРИЛОЖЕНИИ БЕЗ УЧЁТКИ И БЕЗ НАБОРА — НЕТ (как `hasTrainerSection` в `lib/storeTabs.ts`): `computeHasFeature`
 * для незагруженной учётки отвечает «да», и кнопка мелькнула бы у новичка до ответа сервера. Сайт — как у всех
 * гейтов: нет набора — открыто (безопасно к блокировке), сотрудник и `*` — открыто.
 */
export function hasRoomSection(user: AuthUser | null, app: boolean = IS_APP_BUILD): boolean {
  if (app && !user) return false;
  return computeHasFeature(user, 'speaking_peers', app);
}

export function hasLiveSection(user: AuthUser | null, app: boolean = IS_APP_BUILD): boolean {
  if (app && !user) return false;
  return computeHasFeature(user, 'live', app);
}
